import { ReactElement } from 'react';

import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type MedicalDeviceOrderFormLoaderRenderProps = {
   patient: Patient;
};

type MedicalDeviceOrderFormLoaderProps = {
   readonly children: (renderProps: MedicalDeviceOrderFormLoaderRenderProps) => JSX.Element;
   readonly patientId: number;
};

export const MedicalDeviceOrderFormLoader = (props: MedicalDeviceOrderFormLoaderProps): ReactElement => {
   const { data: patient, error: patientError, loading: patientLoading } = useCqrsGet<Patient>(() => {
      const query = new PatientQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (patientLoading) {
      return <LoaderSpinner />;
   }

   if (patientError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      patient: patient,
   });
};
